document.querySelectorAll('.sidebar li a').forEach((element) => {
    element.classList.remove('bg-active', 'text-active-text');
});

document.querySelectorAll('.sidebar li:nth-child(6) a').forEach((element) => {
    element.classList.add('bg-active', 'text-active-text');
});

// import("./breadcrumbs.js").then(function (breadcrumb) {
//     breadcrumb.setCrumbs({
//         1: {
//             href: "standings.html",
//             text: "Standings"
//         },
//         2: {
//             href: "",
//             text: "GT3 Endurance"
//         }
//     });
// });
